import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  confirmed: true,
  manager_id: null,
  published: null,
  purchased: null,
  user_id: null,
  month: null,
  year: null,
  submit_place: null,
  has_note: null,
  unreachable_submitter: null,
  hasMessage: null,
  people_appearing: null,
  person_who_filmed: null,
  submit_other_website: null,
  aggrement_with_another_company: null,
  from: null,
  to: null,
  apiActiveOne: true,
  apiActiveTwo: true,
  check:false
};

const publishedCleareddSlice = createSlice({
  name: "publishedCleareddSlice",
  initialState,
  reducers: {
    setApiActiveOne: (state, action) => {
      state.apiActiveOne = action.payload;
    },
    setApiActiveTwo: (state, action) => {
      state.apiActiveTwo = action.payload;
    },
    setConfirmed: (state, action) => {
      state.confirmed = action.payload;
    },
    setManagerId: (state, action) => {
      state.manager_id = action.payload;
    },
    setPublished: (state, action) => {
      state.published = action.payload;
    },
    setPurchased: (state, action) => {
      state.purchased = action.payload;
    },
    setUserId: (state, action) => {
      state.user_id = action.payload;
    },
    setMonth: (state, action) => {
      state.month = action.payload;
    },
    setYear: (state, action) => {
      state.year = action.payload;
    },
    setSubmitPlace: (state, action) => {
      state.submit_place = action.payload;
    },
    setHasNote: (state, action) => {
      state.has_note = action.payload;
    },
    setUnreachableSubmitter: (state, action) => {
      state.unreachable_submitter = action.payload;
    },
    setHasMessage: (state, action) => {
      state.hasMessage = action.payload;
    },
    setPeopleAppearing: (state, action) => {
      state.people_appearing = action.payload;
    },
    setPersonWhoFilmed: (state, action) => {
      state.person_who_filmed = action.payload;
    },
    setSubmitOtherWebsite: (state, action) => {
      state.submit_other_website = action.payload;
    },
    setAgreementWithAnotherCompany: (state, action) => {
      state.aggrement_with_another_company = action.payload;
    },
    setFrom: (state, action) => {
      state.from = action.payload;
    },
    setTo: (state, action) => {
      state.to = action.payload;
    },
    setCheck: (state, action) => {
      state.check = action.payload;
    },
  },
});

export const {
  setConfirmed,
  setManagerId,
  setPublished,
  setPurchased,
  setUserId,
  setMonth,
  setYear,
  setSubmitPlace,
  setHasNote,
  setUnreachableSubmitter,
  setHasMessage,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setAgreementWithAnotherCompany,
  setFrom,
  setTo,
  setApiActiveOne,
  setApiActiveTwo,
  setCheck
} = publishedCleareddSlice.actions;

export default publishedCleareddSlice.reducer;
